module.exports = __webpack_public_path__ + "assets/img/worldviewImg-d36c72e2.png";